import React, { useState, useEffect } from "react";

export default function SplashScreen({ onFinish }) {
  const [fase, setFase] = useState("entrando"); // entrando | visivel | saindo

  useEffect(() => {
    // Fade in já acontece pelo CSS
    // Fica visível por 1.8s depois some
    const t1 = setTimeout(() => setFase("saindo"), 1800);
    const t2 = setTimeout(() => onFinish(), 2400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onFinish]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "#0a0a0f",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
        opacity: fase === "saindo" ? 0 : 1,
        transition: "opacity 0.6s ease",
      }}
    >
      {/* Logo com pulso suave */}
      <div
        style={{
          animation: "splashPulse 1.8s ease-in-out infinite",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="/logo-impostor.png"
          alt="Descubra o Impostor"
          onError={(e) => { e.target.style.display = 'none'; }}
          style={{
            width: 180,
            height: 180,
            objectFit: "contain",
            borderRadius: "50%",
            boxShadow: "0 0 60px rgba(255, 107, 62, 0.5), 0 0 120px rgba(255, 62, 62, 0.2)",
          }}
        />
      </div>

      {/* Nome do jogo */}
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "2rem",
            letterSpacing: "0.12em",
            color: "#ffffff",
            lineHeight: 1,
          }}
        >
          DESCUBRA O
        </div>
        <div
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "2.6rem",
            letterSpacing: "0.12em",
            color: "#ff3e3e",
            lineHeight: 1,
            textShadow: "0 0 20px rgba(255,62,62,0.6)",
          }}
        >
          IMPOSTOR
        </div>
      </div>

      {/* Pontinhos de carregamento */}
      <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: "#ff3e3e",
              animation: `splashDot 1.2s ease-in-out ${i * 0.2}s infinite`,
              opacity: 0.4,
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes splashPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.04); }
        }
        @keyframes splashDot {
          0%, 100% { opacity: 0.4; transform: translateY(0); }
          50% { opacity: 1; transform: translateY(-4px); }
        }
      `}</style>
    </div>
  );
}
